<style scoped>
</style>
<template>
    <div>

        <div class="col-md-12" >
                <a class="btn btn-primary pull-right" @click="NewPatient" style="width:160px;margin:10px; ">
                    <i class="fa fa-plus" />
                    <span>Add New Patient </span>
                </a>
                <a class="btn btn-primary pull-right" @click="refreshIndex = refreshIndex+1" style="width:160px;margin:10px">
                    <i class="fa fa-refresh" />
                    <span>Refresh </span>
                </a>            
        </div>
        <div class="col-md-12">
            <hr/>
            <ServerDatatable @selected="patientSelected" :columns="columns" :source="getRecords" :datachanged="refreshIndex">

            </ServerDatatable>
        </div>
    </div>
    
</template>
<script>
    import Formatter from "../../corecontrols/formatters/Formatter";
    import FmdDal from "../../../scripts/FmdDal";
    import ServerDatatable from "../../corecontrols/serverDatatable/serverDatatable.scp.html"
    import toastr from 'toastr'
    export default {
        props: [],
        mounted() {
            this.dal = new FmdDal(this.$root.CurrentUnitId, this.$root.UiSession);
            this.refreshIndex++;
        },
        data: function () {
            return {
                dal: null,
                refreshIndex:0,
                columns: [
                    { name: "FirstName", data: "firstName" },
                    { name: "MiddleName", data: "middleName", "orderable": false },
                    { name: "LastName", data: "lastName", "orderable": true },
                    {
                        name: "Dob", data: "dob", "orderable": false, render: function (data) {
                            return Formatter.FormatDate(data)
                        }
                    },
                    { name: "NHS Num", data: "nhsNumber", "orderable": false },
                    { name: "Address", data: "addressLine", "orderable": false },
                    { name: "PostCode", data: "postCode", "orderable": false }
                ]
            }
        },
        methods: {
            NewPatient() {
                this.$router.push({name: 'fmd.newpatient'})
            },
            getRecords(drawIndex, start, length, searchText, sortColumnName, sortDirection, callback) {
                console.log(drawIndex, start, length, searchText, sortColumnName, sortDirection)
                if (this.dal) {
                    this.dal.GetPatients(start, length, searchText, sortColumnName, sortDirection).then(d => {
                        var result = {
                            draw: drawIndex,
                            recordsTotal: d.totalCount,
                            recordsFiltered: d.totalCount,
                            data: d.data
                        }

                        callback(result);
                    })
                }
            },
            patientSelected(row) {
                console.log("Record Selected", row);
                this.$router.push({ path: 'Patient/' + row.id });
            }
        },
        components: {
            ServerDatatable
        }
    }
</script>



// WEBPACK FOOTER //
// Patients.scp.html?3f1e2e51